import axios from '../axios';
import { getApiPath } from '../utils';

const baseUrl = getApiPath();

/**
 * 获取列表页列配置
 * @param {Object} data - 输入参数
 * @param {string} data.code - 配置平台的列表页配置 code
 * @param {string} data.elsAccount - business account
 * @see @qqt-vue/manage-list
 */
const listConfigByCode = (data) => {
  const url = `${baseUrl}/ElsLayoutConfigService/getListConfigByCode`;

  return axios({
    url: url,
    method: 'post',
    data: data
  });
};

export const LayoutConfigService = {
  listConfigByCode
};
